import { render, staticRenderFns } from "./SlidesMenu.vue?vue&type=template&id=626cde48&scoped=true&"
import script from "./SlidesMenu.vue?vue&type=script&lang=ts&"
export * from "./SlidesMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SlidesMenu.vue?vue&type=style&index=0&id=626cde48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626cde48",
  null
  
)

export default component.exports